import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import CompetitionsService, { CompetitionType, CompetitionsUsersType, CompetitionsUsersTypeElement, CompetitionsUsersWithNames } from "../../services/CompetitionsService";
import { Spinner, SpinnerSize, DefaultButton, PrimaryButton } from "@fluentui/react";
import styles from "./index.module.sass";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Auth from "../../Auth/Auth";
import PortfolioModelWalletService, { ModelWallet, ModelWalletOptions } from "../../services/PortfolioModelWalletService";
import Select from "react-dropdown-select";
import { ElementAmountType} from "../../services/ElementsService";
import BackButton from "../../components/buttons/BackButton";
import { GenericMessageModalWithoutButton } from "../../components/Modals/GenericModal";
import SavingsPlanService, { SavingsPlanType, SavingsPlanTypes } from "../../services/SavingsPlanService";
import { UsersSubscriptionType } from "../../services/UsersSubscriptionService";
import { Link } from "react-router-dom";
import { ErrorModal } from "../../components/Modals/ErrorModal";
import { addCompetitionDataInLs, addCompetitionInLS, ICompetitionInfo } from "../../store/educationalcart/actions";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { setActiveSavingsPlan } from "../../store/auth/actions";
import CompetitionCardFromCompetition from "../../components/competitionCardFromCompetition/CompetitionCardFromCompetition";
import * as S from '@/components/ConvenienceTest/ConvenienceTest.style';
import { CompetitionSelectCont } from "@/components/competitionSelect/CompetitionSelect.style";
import { idSubscriptionEducation } from "../../config";
import { createurl } from "../../utils/createUrl";
import { SavingsPlanAndStatusLite } from "../../components/SavePlans/types/SavePlansTypes";

interface PortfolioModel
{
	portfolioModelId?: number;
}

const CompetitionParticipateNoActivePlan = () =>
{
	const dispatch = useDispatch();
	const location = useLocation();

	const state = location.state as PortfolioModel | undefined;

	const [error, setError] = useState({ status: false, message: "" });
	const [haveError, setHaveError] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);
	const [sending, setSending] = useState<boolean>(false);
	const [refresh, setRefresh] = useState<boolean>(false);

	const { competitionId } = useParams<any>();
	const [competitionLoading, setCompetitionLoading] = useState<boolean>(false);

	const [competition, setCompetition] = useState<CompetitionType>();
	const [elementsAmount, setElementsAmount] = useState<ElementAmountType>();
	const [isModal, setIsModal] = useState<boolean>(false);
	const [showModal, setShowModal] = useState<boolean>(false);
	const [savingsPlans, setSavingsPlans] = useState<SavingsPlanAndStatusLite[]>();
	const [chargedSavingPlans, setChargedSavingPlans] = useState<boolean>(false);
	const [chargedModelPortfolio, setChargedModelPortfolio] = useState<boolean>(false);
	const [selectedModelPortfolio, setSelectedModelPortfolio] = useState<number>();
	const [savingPlanModelPortfolios, setSavingPlanModelPortfolios] = useState<ModelWalletOptions[]>();

	const history = useHistory();
	const activePlan = useSelector((state: RootStateOrAny) => state.auth.userActivePlan);
	const user = Auth.getUserProfile();

	useEffect(() =>
	{
		const storedPlan = Auth.getActivePlan();
		if(storedPlan?.id !== undefined && activePlan?.id === undefined)
		{
			dispatch(setActiveSavingsPlan({ ...storedPlan, sync: true }));
		}
	}, [activePlan?.id, dispatch]);

	useEffect(() =>
	{
		setCompetitionLoading(false);

		CompetitionsService.getCompetition(competitionId).then((response: CompetitionType) =>
        {
            setCompetition(response);
            setLoading(false);
        },
        (error: any) =>
        {
            // Sin respuesta del servidor (red, timeout) error.response no existe
            setError({ status: true, message: (typeof error?.response?.data === "string" && error.response.data) || "No se ha podido cargar la competición. Por favor, inténtalo de nuevo más tarde." });
        })
        .finally(() =>
		{
			setCompetitionLoading(true);
		});
     // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() =>
	{
		const fetchSavingsPlans = async () =>
		{
			try
			{
				setLoading(true);

				const res = await SavingsPlanService.getSavingsPlansAndStatusLite(user.id);
				if(res.length > 0 && res !== undefined)
				{
					const savingPlan = res.filter((e: any) => e.status === 4 && e.type !== 0);

					setSavingsPlans(savingPlan);
					setChargedSavingPlans(true);
					Auth.setActivePlan(savingPlan[0]);
					dispatch(setActiveSavingsPlan(savingPlan[0]));

					if(savingPlan.length > 0 && savingPlan[0].id !== undefined)
					{
						try
						{
							const modelPortfolio = await PortfolioModelWalletService.getModelWallets(savingPlan[0].id);

							const spModelPortfolios = modelPortfolio.map((portfolio: ModelWallet) => (
                            {
								value: portfolio.id,
								label: portfolio.name,
							}));

							setSavingPlanModelPortfolios(spModelPortfolios);

							if(state?.portfolioModelId !== undefined)
							{
								var selected = spModelPortfolios.find(e => e.value === state?.portfolioModelId);
								if(selected !== undefined)
								{
									setSelectedModelPortfolio(selected.value);
								}
							}
                            else
							{
								setSelectedModelPortfolio(undefined);
							}

						}
                        catch(error)
						{
							setError({status: true, message: `Error al obtener las carteras modelo: ${error}`});
						}
					}
				}
				else
				{
					setChargedSavingPlans(true);
				}
			}
            catch(error)
			{
				setError({status: true, message: `Error al obtener los planes de ahorro: ${error}`});
			}
            finally
			{
				setChargedModelPortfolio(true);
				setLoading(false);
			}
		};

		if(user.id !== undefined)
		{
			fetchSavingsPlans();
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refresh, user.id]);

	if(competitionId === undefined)
	{
		return(
			<DocumentTitle title="IronIA - Competiciones">
				<div>
					<BackButton />
					<div className="ms-Grid-row">
						<div className="ms-Grid-col ms-sm12">
							<h2>Competiciones</h2>
						</div>
					</div>
					<p style={{marginTop: "20px"}}>Error: No hemos podido procesar tu petición. Porfavor, vuelve a intentarlo.</p>
				</div>
			</DocumentTitle>
		);
	}

	const createPlanEducative = () =>
	{
		setLoading(true);

		//Si es calidad es 41 y si es realidad es 37
		const userSubscription: UsersSubscriptionType =
        {
			userId: user.id,
			subscriptionId: parseInt(idSubscriptionEducation)
		}

		const savingPlan: SavingsPlanType =
        {
			userId: user.id,
			name: "Educación Financiera",
			type: SavingsPlanTypes.FinancialEducation,
			status: 4,
			usersSubscription: userSubscription,
			configurationMapStep: "1.1",
		}

		SavingsPlanService.createSavingsPlan(savingPlan).then((response: any) =>
        {
            setRefresh((prevState: boolean) => !prevState);
            setLoading(false);

            var item: any =
            {
                planId: response.id,
                planName: response.name,
                userId: response.userId,
                type: response.type,
                status: 4,
                outdated: false,
                outdatedContract: true,
                cancelled: false,
                portfolio: null,
                finametrixContract: null,
                userSubscriptionId: response.userSubscriptionId,
            };

            Auth.setActivePlan(item);
            dispatch(setActiveSavingsPlan(item));
        },
        (error: any) =>
        {
            // Se quita el spinner para que el modal de error sea visible y se pueda reintentar
            setLoading(false);
            setError({status: true, message: (typeof error?.response?.data === "string" && error.response.data) || "No se ha podido crear el plan de cartera. Por favor, inténtalo de nuevo más tarde."});
        });
	}

	const includeCompetitionInLocalHost = () =>
	{
		const competitionInfo: ICompetitionInfo =
        {
			name: competition!.name!,
			competitionId: competitionId,
			isPromotionated: competition!.isPromocionated!,
			origin: "participate"
		};

		dispatch(addCompetitionDataInLs(competitionInfo));
		dispatch(addCompetitionInLS(competitionId));
	}

	const process = () =>
	{
		const participationValues: CompetitionsUsersTypeElement =
        {
			competitionId: competitionId,
			savingsPlanId: activePlan!.id,
			portfolioModelId: selectedModelPortfolio ?? 0,
			userId: user.id
		};

        CompetitionsService.inscribeInCompetition(participationValues).then((response: CompetitionsUsersType) =>
        {
            if(competition?.price === 0)
            {
                if(competition.asociatedContractId != null)
                {
                    //CASO E
                    history.push("/competition/nap/contract", { competitionUserObject: response, competition: competition, fromEmail: true })
                }
                else
                {
                    //CASO F
                    setIsModal(true);
                    setShowModal(true);
                }
            }
            else
            {
                if(competition?.typeOfPrice === 3)
                {
                    //CASO D
                    const externalUrl = competition.urlPayment?.startsWith("http") ? competition.urlPayment : `https://${competition.urlPayment}`;
                    window.open(externalUrl, "_blank");
                    history.push(`/competition/${createurl(competition.name)}-${competition.id}`, { competitionId: competition.id });
                }
            }
        },
        (error: any) =>
        {
            setError({status: true, message: (typeof error?.response?.data === "string" && error.response.data) || "No se ha podido registrar tu inscripción. Por favor, inténtalo de nuevo más tarde."});
        })
        .finally(() =>
        {
            setSending(false);
        });
    }

	const participate = () =>
	{
		//Versión anterior
		// A. € - nuestra plataforma - SI contrato ===> contrato - firma (SMS) - inespay
		// x B. € - nuestra plataforma - NO contrato ===> inespay
		// x C. € - OTRA plataforma - SI contrato    ===> contrato - firma (SMS) - url
		// D. € - OTRA plataforma - NO contrato    ===> url
		// E. No € - SÍ contrato - EMAIL           ===> contrato - firma (email)
		// x F. No € - NO contrato                   ===> -

		//-- Para suscritos
		// € - nuestra plataforma - SI contrato ===> contrato - firma (SMS) - inespay
		// € - nuestra plataforma - NO contrato ===> inespay
		// € - OTRA plataforma - SI contrato    ===> contrato - firma (SMS) - url
		// € - OTRA plataforma - NO contrato    ===> url
		// Elements - SI contrato - EMAIL       ===> contrato - firma (email)
		//x Elements - NO contrato               ===> -

		//Versión nueva:

		// A. € - nuestra plataforma - SI contrato ===> contrato - firma (SMS) - inespay
		// D. € - OTRA plataforma - NO contrato    ===> url
		// E. No € - SÍ contrato - EMAIL           ===> contrato - firma (email)

		//typeOfPrice == 0 -- elements IA 
		//typeOfPrice == 1 -- elements Agua
		//typeOfPrice == 2 -- dinero en nuestra plataforma
		//typeOfPrice == 3 -- dinero en su plataforma - tiene url

		setSending(true);

		if(selectedModelPortfolio === undefined)
		{
			setSending(false);
			return setHaveError(true);
		}

		// Sin plan activo cargado no se puede construir la inscripción (antes lanzaba un TypeError y el botón se quedaba bloqueado)
		if(activePlan?.id === undefined)
		{
			setSending(false);
			return setError({status: true, message: "No se ha podido cargar tu plan de cartera. Por favor, recarga la página e inténtalo de nuevo."});
		}

		const participationObject: CompetitionsUsersWithNames =
        {
			competitionId: competitionId,
			savingsPlanId: activePlan!.id,
			portfolioModelId: selectedModelPortfolio ?? 0,
			savingPlanName: activePlan!.name,
			portfolioModelName: savingPlanModelPortfolios?.find(e => e.value === selectedModelPortfolio)?.label,
			userId: user.id,
			competition: competition
		};

		if(competition?.price === 0)
		{
			//Inscripción gratuita
			// E. No € - SÍ contrato - EMAIL           ===> contrato - firma (email)
			// F. No € - NO contrato                   ===> -
			process();
		}
        else
		{
			if(competition?.typeOfPrice === 2)
			{ // Dinero en nuestra plataforma
				if(competition?.asociatedContractId)
				{
					// A. € - nuestra plataforma - SI contrato
					history.push("/competition/sign-me-up", {competitionInscripcion: participationObject});
				}
                else
				{
					// x B. € - nuestra plataforma - NO contrato ===> inespay
					setSending(false);
					setError({status: true, message: "Se ha producido un error con la competición. Por favor, contacta con info@ironia.tech."});
					console.error("La competición debe llevar asocada un contrato");
				}
			}
            else if(competition?.typeOfPrice === 3)
			{ // Dinero en otra plataforma
				if(competition?.asociatedContractId)
				{
					// x C. € - OTRA plataforma - SI contrato
					setSending(false);
					setError({status: true, message: "Se ha producido un error con la competición. Porfavor, contacta con info@ironia.tech."});
					console.error("La competición por pago externo no debe incluir un contrato asociado.");
				}
                else
				{
					// D. € - OTRA plataforma - NO contrato
					process();
				}
			}
            else if(competition?.typeOfPrice === 0 || competition?.typeOfPrice === 1)
			{ // Elements IA o Elements Agua
				setSending(false);
				return setError({status: true, message: "No puedes participar en esta competición ya que requiere un plan de cartera activo."});
			}

			setLoading(false);
		}
	}

	return(
		<DocumentTitle title="IronIA - Competiciones">
			<section className={`${styles.index}`}>
				<BackButton />
				<div className="ms-Grid-row">
					<div className="ms-Grid-col ms-sm12">
						<h2>Competiciones</h2>
					</div>
				</div>
				{loading && <Spinner size={SpinnerSize.large} />}
				{!loading &&
                (
					<div style={{display: "flex"}}>
						<div style={{width: "50%"}}>
							<article style={{display: "flex", flexDirection: "column", justifyContent: "space-between"}} className={`${styles.card} rounded background-background`}>
								<div className="ms-Grid-row">
									<div className="ms-Grid-col ms-sm12">
										<p className="descriptioncompetition" style={{marginBottom: "10px"}}>
											Selecciona la cartera modelo con la que deseas participar en
											la competición. La rentabilidad de la cartera durante el
											periodo de competición determinara a los ganadores.
										</p>
										{(competition?.typeOfPrice === 0 || competition?.typeOfPrice === 1) &&
											<p className="descriptioncompetition">
												Esta competición es a tres ganadores: el que más
												rentabilidad obtenga se lleva el 50% de los Elements de
												los participantes, el segundo el 30% y el tercero el 20%"{" "}
											</p>
										}
										<div style={{marginBottom: "14px", marginTop: "26px"}}>
											{/* Si no tiene plan - boton crear, si tiene plan, el plan educativo sin poder editar */}
											{!chargedSavingPlans ?
												<Spinner size={SpinnerSize.small} className="button-spinner ms-Grid-col ms-sm1 ms-md1 ms-lg1 ms-xl1 " />
												: (savingsPlans === undefined || savingsPlans.length === 0) ?
													<div>
														<p style={{ marginBottom: "10px" }}>Pulsa en el botón Crear para crear el Plan de Cartera:</p>
														<PrimaryButton
															//className="rounded"
															style={{
																marginTop: "0px",
																marginLeft: "8px",
																marginRight: "3px",
																width: "100px",
																height: "40px",
																borderRadius: "60px"
															}}
															onClick={createPlanEducative}
														>
															Crear
														</PrimaryButton>  </div> :
													<div>
														{/*//@ts-ignore */}
														<CompetitionSelectCont>
															<S.Label>Plan de Cartera</S.Label>
															{/*//@ts-ignore */}
															<Select
																options={savingsPlans.map((sp) => ({
																	value: sp.id,
																	label: sp.name,
																}))}
																style={{ opacity: "65%", zIndex: 4 }}
																placeholder=""
																values={[
																	{
																		value: savingsPlans[0]?.id,
																		label: savingsPlans[0]?.name,
																	},
																]}
																searchable={false}
																required
																disabled={true}

															/>
														</CompetitionSelectCont>
													</div>
											}
										</div>
										<div className="ms-Grid-row">
											{!chargedModelPortfolio && <Spinner size={SpinnerSize.small} className="button-spinner ms-Grid-col ms-sm1 ms-md1 ms-lg1 ms-xl1 " />}
											{chargedModelPortfolio &&
												(
													savingsPlans && savingsPlans?.length > 0 ?
														savingPlanModelPortfolios === undefined
															|| (savingPlanModelPortfolios === undefined
																|| savingPlanModelPortfolios.length === 0)
															?
															<div>
																<p style={{ marginBottom: "10px" }}>Pulsa en el botón Crear para crear la Cartera Modelo:</p>
																<Link to={"/cart-ef"} className="color-black">
																	<PrimaryButton
																		//className="rounded"
																		disabled={!savingsPlans || savingsPlans.length === 0}
																		style={{
																			marginTop: "0px",
																			marginLeft: "8px",
																			marginRight: "3px",
																			width: "100px",
																			height: "40px",
																			borderRadius: "60px"
																		}}

																	>
																		Crear
																	</PrimaryButton>
																</Link>
															</div>
															:
															<div style={{ display: "flex", alignItems: "center" }}>
																{/*//@ts-ignore */}
																<CompetitionSelectCont>
																	<S.Label>Cartera Modelo</S.Label>
																	{/*//@ts-ignore */}
																	<Select
																		options={savingPlanModelPortfolios ?? []}
																		placeholder=""
																		onChange={(selectedOptions) =>
																		{
																			setSelectedModelPortfolio(selectedOptions[0]?.value || undefined)
																		}}
																		values={
																			selectedModelPortfolio
																				? [
																					// Busca el label asociado al value seleccionado
																					{
																						value: selectedModelPortfolio,
																						label: savingPlanModelPortfolios?.find(
																							(portfolio) => portfolio.value === selectedModelPortfolio
																						)?.label || "", // Si no se encuentra, deja un string vacío
																					},
																				]
																				: []
																		}
																		searchable={false}
																		required
																		style={{ zIndex: 4 }}
																	/>
																</CompetitionSelectCont>
																<Link to={"/cart-ef"} className="color-black">
																	<PrimaryButton
																		//className="rounded"
																		disabled={!savingsPlans || savingsPlans.length === 0}
																		style={{
																			marginRight: "3px",
																			width: "100px",
																			height: "40px",
																			borderRadius: "60px",
																			marginLeft: "20px",
																			marginTop: "30px"
																		}}
																		onClick={includeCompetitionInLocalHost}
																	>
																		Crear
																	</PrimaryButton>
																</Link>
															</div>
														: <></>)}

										</div>
										<div className="ms-Grid-row">
											<div className="ms-Grid-col ms-sm2 ms-md2 ms-lg2 ms-xl2" />
											{haveError && selectedModelPortfolio === undefined && (
												<p className="ms-Grid-col ms-sm10 ms-md10 ms-lg10 ms-xl10" style={{ color: "red", marginTop: "6px" }}>
													Debes seleccionar al menos una cartera modelo
												</p>
											)}
										</div>
									</div>

								</div>
								<div
									style={{
										display: "flex",
										justifyContent: "right",
										marginBottom: "10px"
									}}
								>
									<DefaultButton
										className="button tiny-primary-button"
										onClick={() => history.push("/competitions")}
										disabled={sending}
									>
										Cancelar
									</DefaultButton>

									<DefaultButton
										className="button tiny-primary-button"
										type="submit"
										disabled={
											sending ||
											(competition !== undefined &&
												elementsAmount !== undefined &&
												competition.typeOfPrice === 1 &&
												competition?.price > elementsAmount?.elementWater) ||
											(competition !== undefined &&
												elementsAmount !== undefined &&
												competition.typeOfPrice === 0 &&
												competition?.price > elementsAmount?.elementIA) ||
											(selectedModelPortfolio === undefined)
										}
										onClick={participate}
									>
										{sending &&
                                        (
											<Spinner
												size={SpinnerSize.small}
												className="button-spinner"
											/>
										)}
										Participar
									</DefaultButton>
								</div>
							</article>

						</div>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignContent: "center",
								width: "50%",
							}}
						>
							<article
								className={`ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl3 rounded background-background`}
								style={{ alignSelf: "center" }}
							>
								{!competitionLoading && <Spinner size={SpinnerSize.large} />}
								{/* Si la competición no se ha podido cargar no se pinta la tarjeta (el error se muestra en el modal) */}
								{competitionLoading && competition !== undefined && <CompetitionCardFromCompetition
									competition={competition!}
									toJoin={true}
									idCompetition={competitionId}
								/>}


							</article>
						</div>
						<ErrorModal
							title="Ha ocurrido un error al procesar tu solicitud"
							body={
								<div>
									<p>{error.message}</p>
								</div>
							}
							size="sm"
							btnSubmitText="Aceptar"
							showModal={error.status}
							onSubmit={() =>
							{
								setError({ status: false, message: "" });
							}}
							onClose={() =>
							{
								setError({ status: false, message: "" });
							}}
						/>
						{isModal && (
							<GenericMessageModalWithoutButton
								title="Inscripción registrada"
								body={
									competition !== undefined ?
										<p> Tu inscripción ha sido registrada. Pulsa el boton aceptar para continuar.</p> :
										<p> Tu inscripción ha sido registrada. Pulsa el boton aceptar para continuar.</p>
								}
								btnSubmitText="Aceptar"
								showModal={showModal}
								onSubmit={() =>
								{
									setShowModal(false);
									competition !== undefined && history.push(`/competition/${createurl(competition.name)}-${competition.id}`, { competitionId: competition.id });
								}}
								onClose={() =>
								{
									setShowModal(false);
									history.push("/competitions");
								}}
							></GenericMessageModalWithoutButton>
						)}
					</div>
				)}
			</section>
		</DocumentTitle>
	);
};

export default CompetitionParticipateNoActivePlan;